import * as Yup from 'yup';

export const AnnouncementValidation = Yup.object({
  title: Yup.string()
    .min(1, 'Title must be at least 1 character long')
    .max(255, 'Title must not exceed 255 characters')
    .required('Title is required'),
  description: Yup.string()
    .min(1, 'Description must be at least 1 character long')
    .max(1000, 'Description must not exceed 1000 characters')
    .required('Description is required'),
  link: Yup.string()
    .url('Please enter a valid URL')
    .optional()
    .nullable(),
  scheduledAt: Yup.date()
    .nullable()
    .optional(),
  url: Yup.string()
    .optional()
    .nullable(),
});
